import React from "react";
import { Box, Typography, Paper } from "@mui/material";

export default function PrivacyPolicy() {
  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #fff3e0 0%, #ffe0b2 100%)",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: "10vw",
        pb: 8,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 6,
          width: "80%",
          maxWidth: "900px",
          borderRadius: "20px",
          backgroundColor: "rgba(255,255,255,0.9)",
          backdropFilter: "blur(8px)",
          boxShadow: "0px 10px 25px rgba(255, 102, 0, 0.2)",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            fontWeight: 800,
            color: "#ff6600",
            letterSpacing: "1px",
            mb: 4,
          }}
        >
          Privacy Policy
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "#333", fontSize: "1.15rem", fontWeight: 500, mb: 2 }}
        >
          At <strong>Cosmical Calculator</strong>, your privacy matters to us.
          This Privacy Policy explains how we collect, use, and protect your
          personal information.
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "#333", fontSize: "1.15rem", fontWeight: 500, mb: 2 }}
        >
          <strong>Data We Collect:</strong> We may collect your name, contact
          details, and birth information to provide personalized astrological
          reports and recommendations.
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "#333", fontSize: "1.15rem", fontWeight: 500, mb: 2 }}
        >
          <strong>Use of Information:</strong> The data you share helps us
          improve our accuracy and service quality. We never sell or share your
          personal data with unauthorized third parties.
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "#333", fontSize: "1.15rem", fontWeight: 500, mb: 2 }}
        >
          <strong>Cookies & Analytics:</strong> Our website may use cookies and
          analytics tools to understand user preferences and improve experience.
          You can disable cookies anytime via your browser.
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "#333", fontSize: "1.15rem", fontWeight: 500, mb: 2 }}
        >
          <strong>Data Security:</strong> We use modern encryption and secure
          servers to protect your data. However, no online transmission is
          entirely risk-free, so we advise users to take standard precautions.
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "#333", fontSize: "1.15rem", fontWeight: 500, mb: 2 }}
        >
          For any privacy-related queries, please contact us at{" "}
          <span style={{ color: "#ff6600", fontWeight: 700 }}>
            cosmicalculator@gmail.com
          </span>
          .
        </Typography>

        <Typography
          variant="body2"
          sx={{
            textAlign: "center",
            color: "#666",
            fontWeight: 600,
            mt: 4,
            letterSpacing: "0.5px",
          }}
        >
          Last updated: November 2025
        </Typography>
      </Paper>
    </Box>
  );
}
